export const primaryBaseColors = {
    cream: "#fffef4",
    navy: "#02112a",
};
export const primaryShades = {
    cream90: "#e6e6e0",
    cream80: "#cccfcc",
    cream70: "#b3b7b7",
    cream60: "#9a9fa3",
    cream50: "#80878f",
    cream40: "#67707b",
    cream30: "#4e5867",
    cream20: "#354052",
    cream10: "#1b293e",
    cream05: "#0f1d34",
};
export const primaryTints = {
    navy90: "#1b293e",
    navy80: "#354052",
    navy70: "#4e5867",
    navy60: "#67707b",
    navy50: "#80878f",
    navy40: "9a9fa3",
    navy30: "#b3b7b8",
    navy20: "#cccfcc",
    navy10: "#e6e6e0",
    navy05: "#f2f2ea",
};
export const secondaryBaseColors = {
    gold: "#c3c1a8",
};
export const secondaryShades = {
    gold80: "#9c9e8f",
    gold75: "#939588",
    gold70: "#898c82",
    gold50: "#626969",
    gold30: "#3c4650",
};
export const secondaryTints = {
    gold90: "#c9c7b0",
    gold80: "#cfcdb7",
    gold70: "#d5d3bf",
    gold50: "#e1dfce",
    gold20: "#f3f2e5",
};
export const accentBaseColors = {
    parakeetGreen: "#39d435",
    bloodOrange: "#fe665c",
    amber: "#ffb323",
    steelBlue: "#6ea6cd",
    lightBlue: "#8EC7EF",
};
export const accentShades = {
    // Parakeet Green
    parakeetGreen90: "#33C034",
    parakeetGreen50: "#1E7330",
    parakeetGreen40: "#023C30",
    parakeetGreen30: "#0C320B",
    // Blood Orange
    bloodOrange90: "#e55d57",
    bloodOrange70: "#b24d4d",
    //Steel Blue
    steelBlue90: "#6397BD",
    steelBlue80: "#5888ac",
    steelBlue50: "#385C7C",
    avatarSteelBlue: "#043057",
    steelBlue40: "#8EC7EF",
    steelBlue30: "#002B4B",
    //Powder Blue
    powderBlue50: "#5E7D8A",
    powderBlue40: "#03374D",
    // Amber
    amber90: "#CA902B",
    amber80: "#25211A",
};
export const accentTints = {
    // Parakeet Green
    parakeetGreen50: "#9ce995",
    parakeetGreen40: "#C6F6C5",
    parakeetGreen30: "#C3F9BE",
    // Blood Orange
    bloodOrange75: "#fe8c82",
    bloodOrange50: "#ffb2a8",
    // Steel Blue
    steelBlue50: "#b7d2e0",
    steelBlue80: "#8bb8d5",
    steelBlue40: "#BAE4F9",
    steelBlue30: "#40628D",
    steelBlue20: "#E3EFF6",
    // Powder Blue
    powderBlue40: "#DDF3EF",
    // Amber
    amber90: "#925D04",
    amber80: "#FBEBCF",
};
export const chartBaseColors = {
    // Klein Blue
    kleinBlue: "#142edb",
    //Powder Blue
    powderBlue: "#bae8eb",
    // Sage
    sage: "#bfe1be",
};
export const chartShades = {
    // Sage
    sage30: "#3b4f56",
};
export const blackColors = {
    black50: "rgba(0, 0, 0, 0.5)",
};
// The barChartColorMap is for use with the bar chart found on Holdings screen for mobile and web.
export const barChartColorMap = {
    parakeetGreen: {
        palette: {
            0: "#1E7330",
            1: "#238631",
            2: "#289932",
            3: "#2EAD33",
            4: "#33C034",
            5: "#4DD848",
            6: "#61DC5B",
            7: "#74E16E",
            8: "#88E581",
            9: "#9CE995",
        },
    },
    sage: {
        palette: {
            0: "#617974",
            1: "#738E83",
            2: "#86A392",
            3: "#99B7A0",
            4: "#ACCCAF",
            5: "#C5E4C3",
            6: "#CCE7C9",
            7: "#D2EACE",
            8: "#D9EDD4",
            9: "#DFEFD9",
        },
    },
    kleinBlue: {
        palette: {
            0: "#0B2082",
            1: "#0D2294",
            2: "#0F25A6",
            3: "#1028B8",
            4: "#122BC9",
            5: "#2C43DE",
            6: "#4358E0",
            7: "#5B6CE2",
            8: "#7281E5",
            9: "#8996E7",
        },
    },
    steelBlue: {
        palette: {
            0: "#385C7C",
            1: "#436A8C",
            2: "#4E799C",
            3: "#5888AC",
            4: "#6397BD",
            5: "#7DAFD1",
            6: "#8BB8D5",
            7: "#99C0D9",
            8: "#A8C9DD",
            9: "#B7D2E0",
        },
    },
    powderBlue: {
        palette: {
            0: "#5E7D8A",
            1: "#70929E",
            2: "#83A7B1",
            3: "#95BDC4",
            4: "#A8D2D8",
            5: "#C1EAEC",
            6: "#C8ECED",
            7: "#CFEFEE",
            8: "#D6F1EF",
            9: "#DDF3EF",
        },
    },
    gold: {
        palette: {
            0: "#626969",
            1: "#767B76",
            2: "#898C82",
            3: "#9C9E8F",
            4: "#B0AF9B",
            5: "#C9C7B0",
            6: "#CFCDB7",
            7: "#D5D3BF",
            8: "#DBD9C6",
            9: "#E1DFCE",
        },
    },
};
//# sourceMappingURL=colors.js.map